import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

const ImagePreviewModal = ({
  isOpen,
  toggle,
  imageUrl,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        Image Preview
      </ModalHeader>

      <ModalBody className="text-center">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '70vh',
              objectFit: 'contain',
            }}
          />
        ) : (
          <p className="mb-0">No image available.</p>
        )}
      </ModalBody>
    </Modal>
  );
};

ImagePreviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  imageUrl: PropTypes.string,
};

ImagePreviewModal.defaultProps = {
  imageUrl: '',
};

export default ImagePreviewModal;